import { CurationsIndex } from './CurationsIndex';

export default CurationsIndex;
